import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ReportMenu.css';

function ReportMenu({ sessionId, onLeafClick, visible, onClose }) {
  const [currentNode, setCurrentNode] = useState(null);
  const [children, setChildren] = useState([]);
  const [parentId, setParentId] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      loadMenu('reports_root');
    }
  }, [visible]);

  const loadMenu = async (nodeId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `https://demo.iresponse.co.in/cb_api/report_menu/navigate`,
        { session_id: sessionId, node_id: nodeId },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.data.status === 'success') {
        setCurrentNode(response.data.current_node);
        setChildren(response.data.children);
        setParentId(response.data.parent_id);
        setBreadcrumb(response.data.breadcrumb);
        console.log('📊 Navigated to:', response.data.current_node.label);
      }
    } catch (error) {
      console.error('❌ Error loading report menu:', error);
      alert('Failed to load report menu. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleNodeClick = (node) => {
    if (node.type === 'leaf') {
      console.log('📄 Leaf clicked:', node.tool_name);
      onLeafClick(node.tool_name, node.label);
    } else {
      loadMenu(node.id);
    }
  };

  const handleBack = () => {
    if (parentId) {
      loadMenu(parentId);
    } else {
      onClose();
    }
  };

  if (!visible) return null;

  return (
    <div className="report-menu-overlay">
      <div className="report-menu-container">
        <div className="report-menu-header">
          <div className="header-content">
            <h2 className="report-title">
              {currentNode?.label?.replace(/📄|📊|🔥|🌊|🌡️|❄️|📁/g, '').trim() || 'Reports Menu'}
            </h2>
            {breadcrumb.length > 2 && (
<div className="breadcrumb-path" title={breadcrumb.slice(1).join(' › ')}>
                {breadcrumb.slice(1).map((crumb, idx) => (
                  <React.Fragment key={idx}>
                    <span className="breadcrumb-item">{crumb}</span>
                    {idx < breadcrumb.slice(1).length - 1 && (
                      <span className="breadcrumb-separator">›</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <button className="close-menu-btn" onClick={onClose} title="Close menu">
            ✕
          </button>
        </div>

        <div className="menu-navigation-buttons">
          {(parentId || currentNode?.id === 'reports_root') && (
            <button className="back-btn" onClick={handleBack}>
              ← {parentId ? 'Back' : 'Close Menu'}
            </button>
          )}
          {currentNode?.id !== 'reports_root' && parentId && (
            <button className="main-menu-btn" onClick={() => loadMenu('reports_root')}>
              🏠 Reports Menu
            </button>
          )}
        </div>

        <div className="menu-items-grid">
          {loading ? (
            <div className="menu-loading">
              <div className="spinner"></div>
              <p>Loading menu...</p>
            </div>
          ) : (
            children.map((child) => {
              const labelLower = child.label?.toLowerCase() || '';
              const isMISContainer = child.type === 'container' &&
                (labelLower.includes('mis') || labelLower.includes('m.i.s'));

              return (
                <button
                  key={child.id}
                  className={`menu-item ${isMISContainer ? 'mis-container' : child.type}`}
                  style={isMISContainer && currentNode?.label?.includes('Flood Reports') ? { marginTop: '15px' } : {}}
                  onClick={() => handleNodeClick(child)}
                  disabled={loading}
                >
                  {/* Show document icon for leaf reports */}
                  <span className="menu-item-icon">
                    {child.icon || (child.type === 'leaf' ? '📄' : isMISContainer ? '📊' : '')}
                  </span>

                  <span className="menu-item-label">{child.label}</span>

                  {/* Arrow only for non-MIS containers */}
                  {child.type === 'container' && !isMISContainer && (
                    <span className="menu-item-arrow">→</span>
                  )}
                </button>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default ReportMenu;